import React from "react";

export const Indicators = (props)=> {
 
    return (
        <div className="w-[250px] mx-auto flex flex-row gap-[10px] items-center justify-center ">
            {
                props.data.map((item,index)=> (
                    <span key={index} onClick={()=> props.click(index)} className={props.active === index ? 'w-[100px] bg-vesti-700 rounded-[100px] h-[15px] ':'w-[15px] bg-vesti-100 rounded-[100px] h-[15px]' } ></span>
                ))
            }
        </div>
    )
}